import * as types from '../actions/types';

const initialState = {
  report: null,
  loading: false,
  years: null,
  special: null,
  scy: null,
  cathedra: null,
  groups: null,
  period: null,
  schema: null,
  ratingCalc: null,
  portrait: null,
  digitalLoading: null,
  minMaxRating: null,
  loadingRadar: null,
  recalc_loading: null,
  recalc_answer: null,
  students_list: [],
  university: [],
  structure: [],
  training_quality: [],
  info_supp: [],
  staff: [],
  vka: null,
  achieveDetails: null,
  military_profs: null
};
/**
 * 
* @DIGITAL_RATING
 * РЕЙТИНГ-РАСПРЕДЕЛЕНИЕ И ЦИФРОВОЙ ПОРТРЕТ 
 * @returns 
 */
export default function report(state = initialState, action) {
  switch (action.type) {
    case types.GET_SPECIALTY:
      return {
        ...state,
        special: action.payload,
      };
    case types.GET_REPORT_SCHEMA:
      return {
        ...state,
        schema: action.payload,
      };
    case types.GET_REPORT_MILITARY_PROFS:
      return {
        ...state,
        military_profs: action.payload,
      };
    case types.GET_REPORT_GROUP:
      return {
        ...state,
        groups: action.payload,
      };
    case types.REPORT_ACADEMIC_PERIOD_FETCH_END:
      return {
        ...state,
        period: action.payload.terms,
      };
    case types.GET_REPORT_SCY:
      return {
        ...state,
        scy: action.payload,
      };
    case types.GET_REPORT_CATHEDRA:
      return {
        ...state,
        cathedra: action.payload,
      };
    case types.GET_REPORT_YEARS:
      return {
        ...state,
        years: action.payload,
      };
    case types.SET_REPORT:
      return {
        ...state,
        report: action.payload,
      };
    case types.SET_REPORT_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case types.SET_DIGITAL_PORTRAIT_LOADING:
      return {
        ...state,
        digitalLoading: action.payload,
      };
    case types.GET_RATING_CALC:
      return {
        ...state,
        ratingCalc: action.payload,
      };
    case types.GET_DIGITAL_PORTRAIT:
      return {
        ...state,
        portrait: action.payload,
      };
    case types.MIN_MAX_RATING:
      return {
        ...state,
        minMaxRating : action.payload,
      };
    case types.MIN_MAX_RATING_LOADING:
      return {
        ...state,
        loadingRadar: action.payload,
      };
    case types.RECALC_LOADING:
      return {
        ...state,
        recalc_loading: action.payload,
      };
    case types.RECALC_ANSWER:
      return {
        ...state,
        recalc_answer: action.payload,
      };
    case types.GET_STUDENTS:
      return {
        ...state,
        students_list: action.payload,
      };
    case types.GET_UNIVERSITY:
      return {
        ...state,
        university: action.payload,
      };
    case types.GET_STRUCTURE:
      return {
        ...state,
        structure: action.payload,
      };
    case types.GET_TRAINING_QUALITY:
      return {
        ...state,
        training_quality: action.payload,
      };
    case types.GET_INFO_SUPP:
      return {
        ...state,
        info_supp: action.payload,
      };
    case types.GET_STAFF:
      return {
        ...state,
        staff: action.payload,
      };
    case types.GET_VKA:
      return {
        ...state,
        vka: action.payload,
      };
    case types.SET_ACHIEVE_DETAILS:
      return {
        ...state,
        achieveDetails: action.payload,
      };
    default:
      return state;
  }
}
